<template>
  <h1>
    ...that we at <span style="color: #92a2ff">why do birds</span> <br />
    like birds a lot...
  </h1>
</template>

<script>
export default {
  mounted() {
    setTimeout(() => {
      this.$emit("next");
    }, 2800);
  },
};
</script>

